import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { getBrandInfoFromVnAppZone } from "../../utils/BrandHelper";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import { filterTagType_template } from "./filterTagType_template";

declare let ko: any;

export class tagTypeSubscriptionsEdit_template extends vnTemplate {

    public datasetFilterAutocomplete: filterAutocomplete_template;


    protected getTemplateHtml(): string {
        return /* html */ `
        <div class="w-form w-form-large">
            <div class="form-header">
                <h3 class="form-title icon i-edit" data-bind="text: title"></h3>
                <button class="close-button icon i-close-2" data-bind="event: { click: onClickCancel }" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title icon i-tag">Tag Dataset</strong>
                    <div class="form-group">
                        <label class="form-label">Tag Dataset</label>
                        ${this.datasetFilterAutocomplete.getHtmlBuild()}
                        <!-- ko if: brandOwnerIcon() -->
                            <dl class="double-list">
                                <dt>
                                    <span>Owner</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="attr: { class: brandOwnerIcon() + ' dark square-icon brand-owner' }"></span>
                                </dd>
                            </dl>
                        <!-- /ko -->
                    </div>
                </div>
                <div class="form-body">
                    <!-- ko if: idDataset() -->
                        <strong class="form-sub-title icon i-article">Subscription</strong>

                        <div class="form-group">
                            <div class="form-row">
                                <input type="checkbox" id="default-image" data-bind="checked: defaultImage">
                                <label class="form-label icon i-check" for="default-image">Set Image to use default</label>
                            </div>
                            <div class="form-row">
                                <input type="checkbox" id="default-icon" data-bind="checked: defaultIcon">
                                <label class="form-label icon i-check" for="default-icon">Set Icon to use default</label>
                            </div>
                            <div class="form-row">
                                <input type="checkbox" id="default-image-group" data-bind="checked: defaultImageGroup">
                                <label class="form-label icon i-check" for="default-image-group">Set Image Group to use default</label>
                            </div>
                            <div class="form-row">
                                <input type="checkbox" id="default-color" data-bind="checked: defaultColor">
                                <label class="form-label icon i-check" for="default-color">Set Color to use default</label>
                            </div>
                            <div class="form-row">
                                <input type="checkbox" id="default-affiliate-links" data-bind="checked: defaultAffiliateLinks">
                                <label class="form-label icon i-check" for="default-affiliate-links">Set Affiliate Links to use default</label>
                            </div>
                            <div class="form-row">
                                <input type="checkbox" id="default-selectable" data-bind="checked: defaultSelectable">
                                <label class="form-label icon i-check" for="default-selectable">Set as Selectable in Article Categorization</label>
                            </div>
                        </div>
                    <!-- /ko -->
                </div>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <!-- ko foreach: tagTypes -->
                        <div class="form-group hr" ><hr /></div>
                        <strong class="form-sub-title icon i-article" data-bind="text: name"></strong>
                        <div class="form-group">
                            <dl class="double-list" data-bind="">
                                <dt>
                                    <label for="" class="form-label" style="margin-bottom:0px;">Set Specs to use default</label>
                                </dt>
                                <dd>
                                    <div class="form-check-inline width-auto" >
                                        <input type="radio" value="custom" data-bind="disable: customSpecs().length === 0, attr:  {id: 'custom-default-specs-' + $index(), name: 'radio-default-specs-' + $index()}, checked: defaultSubscription().defaultSpecs">
                                        <label data-bind="attr:  {for: 'custom-default-specs-' + $index()},  style: {'color': customSpecs().length === 0 ? '#cbcbcb' : '#404040'} ">Custom</label>
                                    </div>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" value="all" data-bind="attr:  {id: 'yes-default-specs-' + $index(), name: 'radio-default-specs-' + $index()}, checked: defaultSubscription().defaultSpecs">
                                        <label data-bind="attr:  {for: 'yes-default-specs-' + $index()}">All</label>
                                    </div>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" value="none" data-bind="attr:  {id: 'no-default-specs-' + $index(), name: 'radio-default-specs-' + $index()}, checked: defaultSubscription().defaultSpecs">
                                        <label data-bind="attr:  {for: 'no-default-specs-' + $index()}">None</label>
                                    </div>
                                </dd>
                                <!-- ko if: customSpecs().length === 0 -->
                                <div class="form-row">
                                    <label class="form-label" data-bind="text: 'This Tag Type does not have any Custom Specs'"></label>
                                </div>
                                <!-- /ko -->
                                <!-- ko if: defaultSubscription().defaultSpecs() === 'custom' -->
                                    <div class="subscription-spec">
                                    <!-- ko foreach: customSpecs -->
                                        <div class="form-row">
                                            <input type="checkbox" data-bind="checked: value, attr: { id: reference + '-' + $parentContext.$index() }">
                                            <label class="form-label icon i-check" data-bind="text: label, attr: { for: reference + '-' + $parentContext.$index() }"></label>
                                        </div>
                                    <!-- /ko -->
                                    </div>
                                <!-- /ko -->
                            </dl>
                        </div>
                    <!-- /ko -->
                </div>
            </div>
            <div class="form-footer">
                <div class="form-group">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>
        </div>`;
    }

    protected initPartial(): void {
        this.datasetFilterAutocomplete = new filterAutocomplete_template("datasetFilterAutocomplete", this.getTemplateViewModel(), this.caller);
        this.datasetFilterAutocomplete.setPlaceholder("Tag Type Dataset");
        this.datasetFilterAutocomplete.setNumberOfChars(1);
        this.datasetFilterAutocomplete.setIsGlobalLockEnabled(this.getTemplateViewModel().lockDatasetFilter())
    }

    protected getTemplateName(): string {
        return "tagTypeSubscriptionsListEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "form-create-tag"];
    }

    protected buildViewModel(): any {
        const vm = {
            id: ko.observable(),
            title: ko.pureComputed(() => this.getTemplateViewModel().id() ? "Edit Tag Dataset Subscription" : "Create Tag Dataset Subscription"),
            brandOwnerIcon: ko.observable(null),
            idBrand: ko.observable(null),
            brand: ko.observable(null),

            idDatasetValue: ko.observable(null),
            idDataset: ko.pureComputed({
                read: this.idDatasetRead.bind(this),
                write: this.idDatasetWrite.bind(this),
            }),
            selectedDataset: ko.observable(null),
            datasetName:ko.observable(null),

            tagTypes: ko.observableArray([]),

            defaultImage: ko.observable(""),
            defaultIcon: ko.observable(""),
            defaultImageGroup: ko.observable(""),
            defaultColor: ko.observable(""),
            defaultAffiliateLinks: ko.observable(""),
            defaultSpecs: ko.observable("none"),
            defaultSelectable: ko.observable(""),

            onClickCancel: this.onClickCancel.bind(this),
            onClickSave: this.onClickSave.bind(this),
            lockDatasetFilter: ko.pureComputed(() => !window.location.href.includes("/add/")),
        };

        return vm;
    }

    public getViewModelForRequest() {
        const vm = this.getTemplateViewModel();


        let updatedTagTypes = vm.tagTypes().map((item) => {
            let defaultSpecs = item().defaultSubscription().defaultSpecs();
            let specs = null;
            if(["all","none"].indexOf(defaultSpecs) === -1) {
                specs = item().customSpecs().reduce((result, field) => {
                    result[field.reference] = { label: field.label, value: field.value };
                    return result;
                }, {});
            } else {
                specs = defaultSpecs;
            }
            let itemCopy = ko.toJS(item());
            itemCopy.defaultSubscription = ko.toJS(item().defaultSubscription());
            itemCopy.defaultSubscription.defaultSpecs = specs;
            return itemCopy
        });

        console.log(updatedTagTypes)
        console.log(vm.tagTypes())

        return {
            id: vm.id(),
            tagTypes: updatedTagTypes,
            defaultImage: vm.defaultImage(),
            defaultIcon: vm.defaultIcon(),
            defaultImageGroup: vm.defaultImageGroup(),
            defaultColor: vm.defaultColor(),
            defaultAffiliateLinks: vm.defaultAffiliateLinks(),
            defaultSelectable: vm.defaultSelectable(),
        };
    }

    public idDatasetRead() {
        return this.getTemplateViewModel().idDatasetValue();
    }

    public idDatasetWrite(id) {
        this.getTemplateViewModel().idDatasetValue(id);
        if(id) {
            this.caller.getDatasetTagTypeInfo(id);
        } else {
            this.setTagTypeInfo(null);
        }
    }

    public setTagTypeID(idTagType): void {
        this.getTemplateViewModel().idTagType(idTagType);
    }

    public setDatasetOptions(options) {
        this.datasetFilterAutocomplete.setOptions(options);
    }

    public setTagDatasetSubscription(tagDatasetSubscription): void {
        if(tagDatasetSubscription) {
            const vm = this.getTemplateViewModel();
            vm.idDatasetValue(tagDatasetSubscription.id);
            vm.datasetName(tagDatasetSubscription.name);
            vm.tagTypes.removeAll();
            tagDatasetSubscription.tagTypes.forEach((item)  => {
                item.defaultSubscription ? item.defaultSubscription = ko.observable(item.defaultSubscription) : item.defaultSubscription = ko.observable({});
                vm.tagTypes.push(
                    ko.observable({
                        id: item.id,
                        name: item.name,
                        slug: item.slug,
                        description: item.description,
                        productSchemaTemplate: item.productSchemaTemplate,
                        brandOwner: item.brandOwner,
                        defaultSubscription: ko.observable({
                            id: item.defaultSubscription().id ? item.defaultSubscription().id : null,
                            defaultImage: item.defaultSubscription().defaultImage ? item.defaultSubscription().defaultImage : null,
                            defaultIcon: item.defaultSubscription().defaultIcon ? item.defaultSubscription().defaultIcon : null,
                            defaultImageGroup: item.defaultSubscription().defaultImageGroup ? item.defaultSubscription().defaultImageGroup : null,
                            defaultColor: item.defaultSubscription().defaultColor ? item.defaultSubscription().defaultColor : null,
                            defaultAffiliateLinks: item.defaultSubscription().defaultAffiliateLinks ? item.defaultSubscription().defaultAffiliateLinks : null,
                            defaultSelectable: item.defaultSubscription().defaultSelectable ? item.defaultSubscription().defaultSelectable : null,
                            defaultSpecs: item.defaultSubscription().defaultSpecs ? ko.observable(item.defaultSubscription().defaultSpecs) : ko.observable("none"),
                        }),
                        fields: ko.observableArray(item.fields),
                        customSpecs : ko.observable([]),
                    }))
            });

            vm.tagTypes().forEach((item) => {
                this.setTagTypeInfo(item(), item().defaultSubscription().defaultSpecs());
            });

            this.datasetFilterAutocomplete.setPlaceholder(vm.datasetName());

            const firstTagTypeSubscription = tagDatasetSubscription.tagTypes[0].defaultSubscription()
            vm.defaultImage(firstTagTypeSubscription.defaultImage ? "true" : "");
            vm.defaultIcon(firstTagTypeSubscription.defaultIcon ? "true" : "");
            vm.defaultImageGroup(firstTagTypeSubscription.defaultImageGroup ? "true" : "");
            vm.defaultColor(firstTagTypeSubscription.defaultColor ? "true" : "");
            vm.defaultAffiliateLinks(firstTagTypeSubscription.defaultAffiliateLinks ? "true" : "");
            vm.defaultSelectable(firstTagTypeSubscription.defaultSelectable ? "true" : "");
            
        }
    }

    public setTagTypeInfo(tagType, defaultSpecs: any = "none"): void {
        if(tagType) {
            if(tagType.brandOwner) {
                this.getTemplateViewModel().brandOwnerIcon(tagType.brandOwner.iconImage);
            }

            if(tagType.fields().length > 0) {
                if(["all","none"].indexOf(defaultSpecs) === -1) {
                    tagType.defaultSubscription().defaultSpecs("custom");
                    if(defaultSpecs) {
                        tagType.customSpecs(tagType.fields().map((field) => {
                            return {
                                reference: field.reference,
                                label: field.label,
                                value: defaultSpecs[field.reference] ? defaultSpecs[field.reference].value : '',
                            };
                        }));
                    } else {
                        tagType.customSpecs(tagType.fields().map((field) => {
                            return {
                                reference: field.reference,
                                label: field.label,
                                value: '',
                            };
                        }));
                    }
                } else {
                    tagType.defaultSubscription().defaultSpecs(defaultSpecs);
                    tagType.customSpecs(tagType.fields().map((field) => {
                        return {
                            reference: field.reference,
                            label: field.label,
                            value: '',
                        };
                    }));
                }
            } else {
                tagType.customSpecs([]);
            }

        } else {
            this.getTemplateViewModel().brandOwnerIcon(null);
            this.getTemplateViewModel().tagTypes([]);
        }
    }

    public onClickSave() {
        this.caller.save(this.getViewModelForRequest());
    }

    public onClickCancel() {
        this.caller.cancel();
    }
    public setIdBrand(idBrand): void {

        this.getTemplateViewModel().idBrand(idBrand);
        this.getTemplateViewModel().brand(getBrandInfoFromVnAppZone(this.caller.getVnAppZone()));
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagTypeSubscriptionsEdit_template.ts